var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHidePreview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62012 7.12638V18.8578C2.62012 20.1923 3.702 21.2742 5.03657 21.2742H13.4942C13.9659 21.2742 14.406 21.139 14.778 20.9053L13.9566 19.9743C13.8141 20.0334 13.6579 20.066 13.4942 20.066H5.03657C4.36928 20.066 3.82834 19.5251 3.82834 18.8578V8.4957L2.62012 7.12638ZM14.7024 13.515V3.15083C14.7024 2.48354 14.1614 1.9426 13.4942 1.9426H5.03657C4.87226 1.9426 4.71562 1.9754 4.57282 2.0348L3.75153 1.10401C4.12375 0.869832 4.56434 0.734375 5.03657 0.734375H13.4942C14.8287 0.734375 15.9106 1.81626 15.9106 3.15083V14.8843L14.7024 13.515Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41162 1.94336L17.1186 20.0668",
    stroke: "#7B7B7B",
    strokeWidth: 1.20823,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHidePreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hide-preview.e9afaed6239dbc6e8c35459c4d749ec7.svg";